import React from 'react';
import { Modal, Table, TableColumnsType } from 'antd';
import { formatDate, formatNumber } from '@/utilities/dataUtils';
import { IPaymentInvoiceList } from '@/interfaces/buyer';
import { round } from 'lodash';

interface IProps {
  open: boolean;
  invoiceList: IPaymentInvoiceList[];
  onClose: () => void;
}

const PaymentInvoiceModal: React.FC<IProps> = ({
  invoiceList,
  open,
  onClose,
}) => {
  const handleOk = () => {
    onClose();
  };

  const columns: TableColumnsType<IPaymentInvoiceList> = [
    {
      title: 'ลำดับ',
      dataIndex: '',
      width: 40,
      align: 'center',
      className: 'text-bold',
      render: (_, rec, i) => <div className="font-weight-bold">{i + 1}</div>,
    },
    {
      title: 'เลขที่ใบวางบิล',
      dataIndex: 'BILL_NBR',
      align: 'center',
      className: 'text-bold',
      width: 120,
    },
    {
      title: 'เอกสาร INVOICE',
      dataIndex: 'INV_NBR',
      align: 'center',
      className: 'text-bold',
      width: 120,
    },
    {
      title: 'วันที่เอกสาร',
      dataIndex: 'INV_DATE',
      align: 'center',
      className: 'text-bold',
      width: 120,
      render: (_) => formatDate(_),
    },
    {
      title: 'ใบตั้งหนี้',
      dataIndex: 'VO_REF',
      align: 'center',
      className: 'text-bold',
      width: 120,
    },
    {
      title: 'ยอดเงิน',
      dataIndex: 'INV_AMT',
      align: 'right',
      className: 'text-bold',
      width: 120,
      render: (_) => formatNumber(_, 2),
    },
    {
      title: 'ยอดเงินหัก',
      dataIndex: 'CKH_APPLIED_AMT',
      key: 'CKH_APPLIED_AMT',
      align: 'right',
      className: 'text-bold',
      width: 120,
      render: (_) => formatNumber(_, 2),
    },
    {
      title: 'หัก ณ ที่จ่าย',
      dataIndex: '',
      align: 'right',
      className: 'text-bold',
      width: 120,
      render: (_) => formatNumber(0, 2),
    },
    {
      title: 'คงเหลือ',
      dataIndex: 'INV_AMT',
      align: 'right',
      className: 'text-bold',
      width: 120,
      render: (_, rec) => {
        const diff = round(rec.INV_AMT - Number(rec.CKH_APPLIED_AMT || 0), 2);
        return formatNumber(diff, 2);
      },
    },
  ];

  return (
    <Modal
      title="รายการ INVOICE"
      open={open}
      onCancel={handleOk}
      footer={false}
      // onCancel={handleCancel}
      width={1200}
    >
      <Table<IPaymentInvoiceList>
        columns={columns}
        dataSource={invoiceList}
        size="small"
        bordered
        rowKey={'AR_NBR'}
        pagination={false}
        locale={{
          emptyText: 'ไม่พบรายการ',
        }}
      />
    </Modal>
  );
};

export default PaymentInvoiceModal;
